/**
 * You can use this utils to build the valid url for the <a>
 * @param {string} url
 */
export const withHttp = (url: string) => (!/^https?:\/\//i.test(url) ? `http://${url}` : url);
